import React from 'react';

interface ConditionalProps {
	children: React.ReactNode;
	isVisible: boolean;
}

const Conditional: React.FC<ConditionalProps> = ({
	children,
	isVisible,
}): any => {
	return isVisible ? children : null;
};

export default Conditional;
